import React, { useState, useEffect, useRef } from "react";
import Spinner from "../../components/Tools/spinner";
import { useSelector } from 'react-redux';
import { BankSettlementMail } from "./../../helper/Api";
import DataTable from 'react-data-table-component';
import SubHeader from "../../components/Subheader/Subheader";
import CustomBreadcrumbs from "../../components/Tools/Breadcumbs";
import moment from "moment";
import { Chip } from '@mui/material';

const BankMail = () => {
    const { financialYears, authData } = useSelector((state) => state.authData);
    const fyIdRef = useRef(localStorage.getItem('globalDateId'));
    const fyList = financialYears.payload.fy_list;
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [bankMailRecords, setBankMailRecords] = useState([]);
    const customStyles = {
        headCells: {
        style: {
            fontWeight: "bold",
            fontSize: "14px"
        },
        },
    };
    const handlePageTrigger = () => {
        fyIdRef.current = localStorage.getItem('globalDateId');
    }

    const downloadPPAFun = (url) => {
        try {
            const link = document.createElement('a');
            link.href = url;
            link.download = `bank_settlement.pdf`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }catch(e) {
            console.log('Error downloading PPA', e);
        }
    }


    const columns = [
        {
            name: 'S No',
            selector: (row) => row.id,
            width: "100px"
        },
        {
            name: 'Settlement Date',
            selector: (row) => moment(row.settlement_date, 'YYYY-MM-DD').format('DD-MM-YYYY'),
            sortable: true,
        },
        {
            name: 'Status',
            selector: (row) => {
                if(row.status === 'onhold') {
                    return <Chip label="On Hold" color="warning" />
                } else if(row.status === 'completed') {
                    return <Chip label="Sent to Bank" color="success" />
                }else if(row.status === 'settled') {
                    return <Chip label="Completed" color="secondary" />
                }else {
                    return <Chip label="In Queue" color="primary" />
                }
            },
            sortable: true,
        },
        {
            name: 'Amount',
            selector: (row) => row.amount,
            sortable: true,
            wrap: true
        },
        {
            name: 'Account No',
            selector: (row) => row.account_no,
            sortable: true,
            wrap: true
        },
        {
            name: 'Mail Attachement',
            selector: (row) => {
                return <button type="button" className='btn btn-primary' onClick={ () => downloadPPAFun(row.file_url) }>Mail Attachement</button>
            },
            sortable: true,
            wrap: true,
        },
        {
            name: 'SFTP File',
            selector: (row) => {
                if(row.sftp_file_url) {
                    return <button type="button" className='btn btn-warning' onClick={ () => downloadPPAFun(row.sftp_file_url) }>SFTP File</button>
                }
            },
            sortable: true,
            wrap: true,
        },
        {
            name: 'Created At',
            selector: (row) => row.created_at,
            sortable: true,
            wrap: true,
        }
    ];

    const handleChangeRowsPerPage = (currentRowsPerPage, currentPage) => {
        setRowsPerPage(currentRowsPerPage);
        setCurrentPage(1);
    };

    const fetchBankSettlementMails = async () => {
        try {
            setLoading(true);
            const res = await BankSettlementMail();
            if (res.data.status) {
                setBankMailRecords(res.data.data);
                setLoading(false);
            }
        } catch (error) {
            console.log("fetchBankSettlementMails error", error);
            setLoading(false);
        }
    }

    useEffect(() => {
        fetchBankSettlementMails();
    }, []);

    return (
        <div>
            {loading && <div > <Spinner/> </div>}
            <SubHeader fy_list={fyList} handlePageTrigger={handlePageTrigger}/>
            <div className="row" style={{ padding: "10px 16px" }}>
                <div className="col-md-6">
                    <h4 style={{ color: "#28326f", margin:0}}>Bank Settlement Mail Report</h4>
                    <CustomBreadcrumbs linksArray={[]} title="Bank Settlement Mail Report"/>
                </div>
                <div className="col-md-6">
                    
                </div>
            </div>
            <DataTable
                customStyles={customStyles}
                className="dataTables_wrapper"
                columns={columns}
                data={bankMailRecords}
                fixedHeader
                fixedHeaderScrollHeight="600px"
                pagination
                paginationPerPage={rowsPerPage}
                paginationTotalRows={bankMailRecords.length}
                paginationRowsPerPageOptions={[10, 25, 50, 100]}
                onChangeRowsPerPage={handleChangeRowsPerPage}
            />
        </div>
    )
}

export default BankMail;